import React, { Component } from 'react';
import axios from 'axios';
import './fil.css';

let url = "https://bwapi.onrender.com/filtercat"


// 2?lprice=90000&hprice=1000000
class PriceFilter extends Component {
    filterPrice = (event) => {
        let categoryId = sessionStorage.getItem('categoryId')
        let id = this.props.id;
        let price = event.target.value.split('-');
        let hprice = price[1]
        let lprice = price[0]
        let priceUrl;
        if (event.target.value === '') {
            priceUrl = `${url}/${categoryId}`
        } else {
            priceUrl = `${url}/${categoryId}?lprice=${lprice}&hprice=${hprice}`

        }
        axios.get(priceUrl)
            .then((res) => {
                this.props.categoryPerPrice(res.data)
            })
        
    }
    render() {
        return (
            <>
                <h6 class="fw-bold">Cost filter</h6>
                <div class="py-2 border-bottom ccc ml-3" onChange={this.filterPrice}>
                    <label className="radio">
                        <input type="radio" name="category" value="" />All
                    </label>
                    <label className="radio">
                        <input type="radio" name="category" value="50000-130000" />60,000-1,30,000
                    </label>
                    <label className="radio">
                        <input type="radio" name="category" value="130001-200000" />1,30,000-2,00,000
                    </label>
                    <label className="radio">
                        <input type="radio" name="category" value="200001-300000" />2,00,000-3,00,000
                    </label>
                    <label className="radio">
                        <input type="radio" name="category" value="300001-1000000" />3,00,000-10,00,000
                    </label>
                    <label className="radio">
                        <input type="radio" name="category" value="1000001-3000000" />10,00,000-30,00,000
                    </label>
                </div>
            </>
        )
    }
}
export default PriceFilter;